/**
 * contain some general infos that can be used in other files
 */
// eslint-disable-next-line
export default {
    title: process.env.REACT_APP_WEBSITE_TITLE,
    short_title: process.env.REACT_APP_WEBSITE_SHORT_TITLE,
    subtitle: "Regroupements des fonds coopératifs Citizenfund",
    description: process.env.REACT_APP_WEBSITE_DESC,
    url: process.env.REACT_APP_WEBSITE_URL,
    location: {
      entreprise: {
        name: "Citizenfriends ASBL",
        url: "https://citizenfriends.com",
        num: "BE0797059985"
      },
      number: "",
      street: "Chaussée de la Hulpe, 150",
      CP: "1170",
      town: "Watermael-Boisfort",
      phone: "",
      email: "info@citizenfriends.be",
    },
  };
  